import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function CollectionErrorState() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "320px",
        gap: 1.5,
      }}
    >
      <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "text-primary" }}>
        Something went wrong
      </Typography>
      <Typography
        sx={{ fontSize: "14px", color: "#717171", textAlign: "center", maxWidth: "360px" }}
      >
        We couldn't load your collections. Please refresh the page or try again later.
      </Typography>
    </Box>
  );
}
